/**
 * Estrutura com que toda notícia nova nasce (`config.blocks.initialBlocks`,
 * aplicado pelo `Add.jsx` do Volto).
 *
 * É a MESMA que o seed produz — `with_native_title` + `com_faixa_institucional`
 * em `docs/seed/seed_site.py` —, para uma notícia criada pelo CMS não sair
 * diferente das que já estão no ar.
 *
 * `title`/`description` não guardam texto: leem os campos do próprio conteúdo.
 * Estarem em `blocks_layout` é o que os torna editáveis no canvas em vez de
 * desenhados pela view (decisão 2026-09-08).
 *
 * ⚠️ A faixa entra SEM `items`, de propósito. Este template é config estática
 * e o `Add.jsx` não roda `initialValue` nem `applyBlockDefaults` neste
 * caminho: não há `intl`, então qualquer texto embutido aqui sairia sempre no
 * mesmo idioma — foi o que aconteceu, e uma notícia criada em `/en` nascia com
 * a faixa em português. Quem preenche é o `InstitutionalBlurbEdit`, já dentro
 * do formulário, onde o `intl` do idioma corrente existe.
 */
export const newsItemTemplate = (defaultBlockType = 'slate') => [
  { '@type': 'title' },
  { '@type': 'description' },
  // Um parágrafo vazio para o editor começar a escrever — sem isto a notícia
  // nasce sem lugar óbvio para o texto.
  { '@type': defaultBlockType },
  { '@type': 'institutionalBlurb' },
];

export default newsItemTemplate;
